<template>
  <h3>Экспорт</h3>
  <div class="block">
    <p>Для проведения экспорта денежных потоков нужно нажать на кнопку «Выгрузка потоков» в разделе «Денежные потоки».</p>
    <p>Пользователю предоставлен выбор:</p>
    <ul>
      <li>Источник потоков (прямой или исходящий бизнес)</li>
      <li>Тип потоков (Годовые или месячные)</li>
      <li>Резервной группы (в зависимости от того, в каких группах есть денежные потоки)</li>
      <li>Валюта (рубли, евро и доллары)</li>
      <li>Модель оценки (GMM или PAA)</li>
      <li>Отчетная дата (на какие отчетные даты имеются ДП ООЧП)</li>
    </ul>
    <img src="@/assets/img/guide/export-form.png" alt="" srcset="">
    <h5>Экспорт прямого бизнеса</h5>
    <h6>Годовой экспорт</h6>
    <p>В экспорте годовых денежных потоков есть следующие обязательные шаги:</p>
    <ul>
      <li>Загружены ДП ООЧП на дату перехода (31.12.23) для выбранного портфеля. В данной загрузке необходимо отразить год самой ранней когорты, на основе этого года потребуются расчеты для соответствующих когорт.</li>
      <li>Загружен файл «Прочие потоки» на 31.12.23 для выбранного портфеля. Для каждой когорты заполняется 3 листа. </li>
    </ul>
    <p>Загрузка ДП ОВТ на дату перехода является опциональной. Если загрузка была осуществлена, то на соответствующую отчетную дату будут сформированы потоки в части ОВТ, а также фактические выплаты убытков.</p>
    <p><i>Например, если год самой ранней когорты - 2021й, то ДП ООЧП должны быть загружены и посчитаны также на 31.12.21 и 31.12.22.</i></p>
    <p><i>Например, если год самой ранней когорты - 2021й, то ДП ООЧП должны быть загружены и посчитаны также на 31.12.21 и 31.12.22.</i></p>
    <p>
      <i>
        Например, если была сделана загрузка ДП ОВТ на 31.12.23, то на 31.12.23 для всех когорт, по которым есть балансовые остатки ДП ООЧП на дату перехода (в данном примере – это когорты с 2021 по 2023 год), будут экспортированы потоки ОВТ, а также фактические выплаты за 2023 год.
      </i>
      <b>
        Это не влияет на балансовые остатки на дату перехода, поэтому загрузка ДП ОВТ не является блокирующей.
      </b>
    </p>
    <p>В выгруженных файлах формируется несколько листов в зависимости от количества отчетных дат ДП ООЧП.</p>
    <p><i>Например, если ДП ООЧП загружены на конец 2021, 2022 и 2023 года, то будет сформировано 3 листа.</i></p>
    <img src="@/assets/img/guide/excel-years.png" alt="" srcset="">
    <p>В каждом листе представлены таблицы соответствующие андеррайтинговым таблицам в ПО, в разделе «Заполнение шаблона денежных потоков по ООЧП».</p>
    <img src="@/assets/img/guide/export-excel-table.png" alt="" srcset="">
    <img src="@/assets/img/guide/oocp-template-export.png" alt="" srcset="">
    <h5>Использование Данных в экспорте</h5>
    <p>В годовом экспорте берутся данные как из ПО, так и из загрузки Прочих потоков и ДП ОВТ.</p>
    <h5>GMM</h5>
    <p>1.	ДП ООЧП</p>
    <p>Данные для ООЧСП берутся из раздела «Заполнение шаблона денежных потоков по ООЧП», в котором содержаться результаты соответствующих расчетов. Они заполняют следующие таблицы:</p>
    <ul>
      <li>Ожидаемые оплаченные убытки в части ООЧСП на момент T</li>
      <li>Ожидаемые выплаты по убыткам ООЧСП_T+1</li>
    </ul>
    <p>2.	Прочие потоки</p>
    <p>Данные берутся из загрузочных файлов «Прочие потоки» из листов соответствующей когорты. В загрузочном файле по прочим потоком есть три типа данных (три типа листа):</p>
    <p>Далее представлена сводка данных из загрузочного файла и названия столбцов в экспорте, которые они заполняют.</p>

    <table>
      <tr>
        <th>Столбцы из загрузочного файла</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <td colspan="2">Загрузочный лист «ДП, валюта договора»</td>
      </tr>
      <tr>
        <td>ЕСП</td>
        <td>Заработанная сумма под риском (единицы страхового покрытия), Вал.договора</td>
      </tr>
      <tr>
        <td>Премия</td>
        <td>Страховые премии, Вал.договора</td>
      </tr>
      <tr>
        <td>Аквизиц. комиссия по агентским договорам</td>
        <td>Аквизиционные комиссии по агентским договорам, Вал.договора</td>
      </tr>
      <tr>
        <td>Неаквизиц. комиссия по агентским договорам</td>
        <td>Неаквизиционные комиссии по агентским договорам, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты премии</td>
        <td>Возвраты премий, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты неакв. комм.</td>
        <td>Возвраты неаквизиционных комиссий, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты аквиз. комм. по агентским договорам</td>
        <td>Возварты аквизиционных комиссий по агентским договорам, Вал.договора</td>
      </tr>
      <tr>
        <td colspan="2">Загрузочный лист «ДП, валюта отчетности»</td>
      </tr>
      <tr>
        <td>Аквизиц. комиссия по прочим договорам	</td>
        <td>Аквизиционные комиссии по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Относимые админ. расх.</td>
        <td>Относимые аквизиционные расходы, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Неаквизиц. комиссия по прочим договорам</td>
        <td>Неаквизиц. комиссии по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Относимые админ. расх.</td>
        <td>Относимые расходы, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Возвраты аквиз. комм. по прочим договорам</td>
        <td>Возвраты аквизиционных комиссий по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr>
        <td colspan="2">Загрузочный лист «Ставки дисконтирования»</td>
      </tr>
      <tr>
        <td>Рыночные ставки диск., рубли</td>
        <td>Кривая ставок дисконтирования, определенная на дату первоначального признани, Валюта отчетности</td>
      </tr>
      <tr>
        <td>Рыночные ставки диск., Валюта договора</td>
        <td>Кривая ставок дисконтирования, определенная на дату первоначального признания, Валюта договора</td>
      </tr>
    </table>
    <p>3.	ДП ОВТ</p>
    <p>Данные из ДП ОВТ берутся как с интерфейса, так и из загрузочного файла «ДП ОВТ».</p>
    <p>•	Таблица «Фактические выплаты по убыткам»</p>
    <p>Для заполнения данной таблицы берутся данные из загрузочного файла «ДП ОВТ» на определенную когорту. Для определенных сущностей также берутся данные с интерфейса из ДП ООЧП. Далее представлена таблица, которая описывает логику использования данных:</p>
    <table>
      <tr>
        <th>Листы из загрузочного файла «ДП ОВТ»</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr><td colspan="2">Все данные берутся из загрузки ДП ОВТ</td></tr>
      <tr>
        <td>Оплаченные убытки</td>
        <td>Оплач. убытки, Вал.договора</td>
      </tr>
      <tr>
        <td>Оплаченные нулевые требования</td>
        <td>Урегулироавние нулевых требований, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (прям.)</td>
        <td>Расходы на урегулирование убытков (прямые), Вал.договора</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (проч.)</td>
        <td>Прочие расходы на урегулирование убытков, Вал.договора</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (судеб.)</td>
        <td>Судебные расходы на урегулирование убытков, Вал.договора</td>
      </tr>
      <tr><td colspan="2">Смешанные данные из загрузки «ДП ОВТ» и с интерфейса ДП ООЧП «Выбор доли РУУ…»</td></tr>
      <tr>
        <td></td>
        <td>Расходы по разнице первичных требований и возмещений от РСА, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП «Выбор доли РУУ (косв) в убытках %»</td>
        <td>Расходы на урегулирование убытков (косвенные), Вал.отчетности</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП по Регрессам «Выбор доли поступлений в убытках %»</td>
        <td>Возникн.регр.прав с уч. неполуч. , Вал.договора</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП по ГОТС «Выбор доли поступлений в убытках %»</td>
        <td>Возникн. прав на ГОТС с уч. неполуч., Вал.договора</td>
      </tr>
    </table>
    <p>• Таблица «Ожидаемый поток выплат из резерва убытков T»</p>
    <p>Для заполнения данной таблицы берутся данные с интерфейса из раздела «ДП ОВТ» из таблицы «Данные для аллокации по когортам».</p>
    <h5>PAA</h5>
    <p>Построение таблиц в РАА немного отличается от GMM. Помимо таблиц по андеррайтинговым годам, также представлены таблицы с денежными потоками для ОВСУ на три валюты.</p>
    <img src="@/assets/img/guide/export-paa-excel-table.png" alt="" srcset="">
    <p>Также в конце каждой таблицы находятся фактические денежные потоки на все периоды возникновения:</p>
    <img src="@/assets/img/guide/export-paa-excel-table-detail.png" alt="" srcset="">
    <p>1.	ДП ООЧП</p>
    <p>Данные из ДП ООЧП берутся как с интерфейса, так и из загрузочного файла «ДП ООЧП». Для заполнения следующих столбцов берутся данные из ДП ООЧП с интерфейса из таблицы «Ожидаемые потоки в части ООЧП на момент T»:</p>
    <ul>
      <li>Оплач. убытки, Вал.договора</li>
      <li>Понес.расх. на урег.убытков (прямые), Вал.договора</li>
      <li>Понес. судебн. расх. на урег.убытков, Вал.договора</li>
      <li>Понес. прочие расх. на урег.убытков, Вал.договора</li>
      <li>Возникн.регр.прав с уч. неполуч., Вал.договора</li>
      <li>Возникн. прав на ГОТС с уч. неполуч., Вал.договора</li>
    </ul>
    <p>Также с помощью загрузочного файла «ДП ООЧП» и загрузочного файла «Прочие потоки» заполняется столбец «График призн. выручки, Вал.договора». В Т = 0 данный столбец берет значения из загрузочного файла «ДП ООЧП» из листа «Прогноз выручки» из столбца Когорта ХХХХ, Т = 0. Начиная с Т = 1, подтягиваются данные из загрузочного файла «Прочие потоки» из листа «ДП, валюта договора» (для соответствующей когорты) из столбца «Заработанная премия (факт)».</p>
    <p>2.	Прочие потоки</p>
    <p>Данные берутся из загрузочных файлов «Прочие потоки» из листов соответствующей когорты. В загрузочном файле по прочим потоком есть три типа данных (три типа листа):</p>
    <p>Далее представлена сводка данных из загрузочного файла и названия столбцов в экспорте, которые они заполняют.</p>
    <table>
      <tr>
        <th>Столбцы из загрузочного файла</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <td colspan="2">Загрузочный лист «ДП, валюта договора»</td>
      </tr>
      <tr>
        <td>Премия</td>
        <td>Страховые премии, Вал.договора</td>
      </tr>
      <tr>
        <td>Аквизиц. комиссия по агентским договорам</td>
        <td>Аквизиционные комиссии по агентским договорам, Вал.договора</td>
      </tr>
      <tr>
        <td>Неаквизиц. комиссия по агентским договорам</td>
        <td>Неаквизиционные комиссии по агентским договорам, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты премии</td>
        <td>Возвраты премий, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты неакв. комм.</td>
        <td>Возвраты неаквизиционных комиссий, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты аквиз. комм. по агентским договорам</td>
        <td>Возварты аквизиционных комиссий по агентским договорам, Вал.договора</td>
      </tr>
      <tr><td colspan="2">Загрузочный лист «ДП, валюта отчетности»</td></tr>
      <tr>
        <td>Аквизиц. комиссия по прочим договорам</td>
        <td>Аквизиционные комиссии по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Относимые админ. расх.</td>
        <td>Относимые аквизиционные расходы, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Неаквизиц. комиссия по прочим договорам</td>
        <td>Неаквизиц. комиссии по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Относимые админ. расх.</td>
        <td>Относимые расходы, Вал.отчетности</td>
      </tr>
      <tr>
        <td>Возвраты аквиз. комм. по прочим договорам</td>
        <td>Возвраты аквизиционных комиссий по прочим договорам, Вал.отчетности</td>
      </tr>
      <tr><td colspan="2">Загрузочный лист «Ставки дисконтирования»</td></tr>
      <tr>
        <td>Рыночные ставки диск., рубли</td>
        <td>Рыночные ставки диск., рубли</td>
      </tr>
      <tr>
        <td>Рыночные ставки диск., Валюта договора</td>
        <td>Рыночные ставки диск., Валюта договора</td>
      </tr>
      <tr>
        <td>Ставки диск. при перв.призн., рубли</td>
        <td>Ставки диск. при перв.призн., рубли</td>
      </tr>
      <tr>
        <td>Ставки диск. при перв.призн., Валюта договора</td>
        <td>Ставки диск. при перв.призн., Валюта договора</td>
      </tr>
    </table>
    <p>3.	ДП ОВТ</p>
    <p>Данные из ДП ОВТ берутся как из загрузочного файла «ДП ОВТ», так и с интерфейса.</p>
    <ul>
      <li>Таблица «Профиль убытков, состоявшихся в XXXX» Данная таблица заполняется данными с интерфейса из раздела Заполнение шаблона денежных потоков по ОВТ» из соответствующего андеррайтингового года и из соответствующей когорты профиля убытков.</li>
      <li>Таблица «Фактические ДП, все периоды возникновения убытков» Данная таблица заполняется данными из загрузочных файлов «ДП ОВТ». Далее представлена соответствие листов из загрузочного файла «ДП ОВТ» и столбцов таблицы, которая будет являться результатом экспорта.</li>
    </ul>
    <table>
      <tr>
        <th>Листы из загрузочного файла «ДП ОВТ»</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <th colspan="2">Все данные берутся из загрузки ДП ОВТ</th>
      </tr>
      <tr>
        <td>Оплаченные убытки</td>
        <td>Оплач. Убытки</td>
      </tr>
      <tr>
        <td>Оплаченные нулевые требования</td>
        <td>Урег.нул.треб.</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (прям.)</td>
        <td>Расх. на урег. убытков (прямые)</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (проч.)</td>
        <td>Понесенные РУУ (проч.)	Прочие расх. на урег. Убытков</td>
      </tr>
      <tr>
        <td>Понесенные РУУ (судеб.)</td>
        <td>Судебн. расх. на урег. Убытков</td>
      </tr>
      <tr>
        <th colspan="2">Смешанные данные из загрузки «ДП ОВТ» и с интерфейса ДП ООЧП «Выбор доли РУУ…»</th>
      </tr>
      <tr>
        <td></td>
        <td>Расх. по разнице перв. треб. и возм-й от РСА</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП «Выбор доли РУУ (косв) в убытках %»</td>
        <td>Расх. на урег. убытков (косв.)</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП по Регрессам «Выбор доли поступлений в убытках %»</td>
        <td>Возникн.регр.прав с уч. неполуч.</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП по ГОТС «Выбор доли поступлений в убытках %»</td>
        <td>Оплаченные убытки загрузка «ДП ОВТ» х Таблица с интерфейса ДП ООЧП по ГОТС «Выбор доли поступлений в убытках %»	Возникн. прав на ГОТС с уч. неполуч.</td>
      </tr>
    </table>
    <h5>Месячный экспорт</h5>
    <p>Экспорт месячных денежных потоков можно сделать только на даты, которые равны или больше даты перехода (31.01.2023). Первая выгрузка месячных потоков происходит на 31.01.24, данная выгрузка включает в себя месячные потоки на 31.12.23 и 31.01.24. Далее выгрузка месячных потоков осуществляется за одну отчетную дату.</p>
    <p>В экспорте месячных денежных потоков есть следующие требования для разных сценариев экспорта:</p>
    <ol>
      <li>Загружены только Прочие потоки мес. или ДП ОВТ мес. на отчетную дату</li>
      <ul>
        <li>Выгрузка экспорта проходит без ограничений.</li>
      </ul>
      <li>Загружены ДП ООЧП мес. на отчетную дату</li>
      <ul>
        <li>Загрузка файла «Прочие потоки (мес.)» на отчетную дату является обязательной. В данной загрузке должны быть все когорты, которые есть в файле «ДП ООЧП (мес.)». Также в загрузке могут быть другие когорты, которых нет в ДП ООЧП мес.</li>
        <li>Загрузка ДП ОВТ на отчетную дату не является блокирующей.</li>
      </ul>
    </ol>
    <p>Если экспорт совершается на дату перехода (31.01.2023), то должны быть загружены денежные потоки на 31.12.2023. В данном случае сценарии описанные раннее сохраняются.</p>
    <p>После успешного экспорта пользователь может запустить расчет переданных потоков в ПО «IRAT».</p>
    
    <h5>Экспорт исходящего бизнеса</h5>
    <h6>Годовой экспорт</h6>
    <p>В экспорте годовых денежных потоков есть следующие обязательные шаги:</p>
    <ul>
      <li>Загружен файл «ДП ООЧП (исходящее)» на дату перехода (31.12.23) для выбранного портфеля. В данной загрузке необходимо отразить год самой ранней когорты, на основе этого года потребуются расчеты для соответствующих когорт.</li>
      <li>Загружен файл «Прочие потоки» на 31.12.23 для выбранного портфеля. Для каждой когорты заполняется 3 листа</li>
    </ul>
    <p>Загрузка ДП ОВТ на дату перехода является опциональной. Если загрузка была осуществлена, то на соответствующую отчетную дату будут сформированы потоки в части ОВТ, а также фактические выплаты убытков.</p>
    <p><i>Например, если год самой ранней когорты - 2021й, то ДП ООЧП (исходящее) должны быть загружены и посчитаны также на 31.12.21 и 31.12.22.</i></p>
    <p><i>Например, если есть когорты с 2021 по 2023 годы, соответственно, должны быть заполнены 9 листов в файле «Прочие потоки».</i></p>
    <p><i>Например, если была сделана загрузка ДП ОВТ (исходящее) на 31.12.23, то на 31.12.23 для всех когорт, по которым есть балансовые остатки ДП ООЧП (исходящее) на дату перехода (в данном примере – это когорты с 2021 по 2023 год), будут экспортированы потоки ОВТ, а также фактические выплаты за 2023 год.</i><b>Это не влияет на балансовые остатки на дату перехода, поэтому загрузка ДП ОВТ (исходящее) не является блокирующей.</b></p>
    <p>В выгруженных файлах формируется несколько листов в зависимости от количества отчетных дат ДП ООЧП.</p>
    <p><i>Например, если ДП ООЧП (исходящее) загружены на конец 2021, 2022 и 2023 года, то будет сформировано 3 листа.</i></p>
    <img src="@/assets/img/guide/excel-years.png" alt="" srcset="">
    <p>В каждом листе представлены таблицы соответствующие андеррайтинговым таблицам в ПО, в разделе «Заполнение шаблона денежных потоков по ООЧП».</p>
    <img src="@/assets/img/guide/export-excel-table-re.png" alt="" srcset="">
    <img src="@/assets/img/guide/oocp-template-export-re.png" alt="" srcset="">
    <h5>Использование Данных в экспорте</h5>
    <p>В годовом экспорте берутся данные как из ПО, так и из загрузки файла «Прочие потоки (исходящее)» и ДП ОВТ (исходящее).</p>
    <h5>GMM</h5>
    <p>1.	ДП ООЧП</p>
    <p>Данные для ООЧСП берутся из раздела «Заполнение шаблона денежных потоков по ООЧП», в котором содержаться результаты соответствующих расчетов. Они заполняют следующие таблицы:</p>
    <ul>
      <li>Ожидаемые оплаченные убытки в части ООЧСП на момент T</li>
      <li>Ожидаемые выплаты по убыткам ООЧСП_T+1</li>
    </ul>
    <p>2. Прочие потоки (исходящее)</p>
    <p>Данные берутся из загрузочных файлов «Прочие потоки (исходящее)» из листов соответствующей когорты. В загрузочном файле по прочим потоком есть три типа данных (три типа листа):</p>
    <p>Далее представлена сводка данных из загрузочного файла и названия столбцов в экспорте, которые они заполняют.</p>
    <table>
      <tr>
        <th>Столбцы из загрузочного файла</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «ДП, валюта договора»</th>
      </tr>
      <tr>
        <td>Заработанная сумма под риском (ЕСП)</td>
        <td>Страховая сумма (единицы страхового покрытия)</td>
      </tr>
      <tr>
        <td>Перестраховочная премия</td>
        <td>Перестраховочная премия, Вал.договора</td>
      </tr>
      <tr>
        <td>Перестраховочная комиссия</td>
        <td>Перестраховочная комиссия, Вал.договора</td>
      </tr>
      <tr>
        <td>Аквизиц. Комиссия</td>
        <td>Аквизиц. комиссия, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты премии</td>
        <td>Относимые расх., Вал.отчетности</td>
      </tr>
      <tr>
        <td>Возвраты перестраховочных премий за вычетом перестраховочной комиссии</td>
        <td>Возвраты перестраховочных премий за вычетом перестраховочной комиссии, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты аквизиционных комиссий</td>
        <td>Возвраты аквизиционных денежных потоков, Вал.договора</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «ДП, валюта отчетности»</th>
      </tr>
      <tr>
        <td>Относимые админ. расх</td>
        <td>Относимые расх., Вал.отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «Ставки дисконтирования»</th>
      </tr>
      <tr>
        <td>Ставки диск. при первонач. признании, вал договора</td>
        <td>Кривая ставок дисконтирования, определенная на дату первоначального признани, Валюта договора</td>
      </tr>
      <tr>
        <td>Ставки диск. при первонач. признании, рубли</td>
        <td>Кривая ставок дисконтирования, определенная на дату первоначального признания, Валюта отчетности</td>
      </tr>
      <tr>
        <td>Рыночные ставки, вал договора</td>
        <td>Кривая ставок дисконтирования на текущую отчетную дату, Валюта договора</td>
      </tr>
      <tr>
        <td>Рыночные ставки, рубли</td>
        <td>Кривая ставок дисконтирования на текущую отчетную дату, Валюта отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный файл «Вероятности дефолта»</th>
      </tr>
      <tr>
        <td>Вероятность дефолта, текущая</td>
        <td>Вероятность дефолта перестраховщика в части ООЧСП, определенная на текущую отчетную дату</td>
      </tr>
      <tr>
        <td>Вероятность дефолта, первоначальное признание</td>
        <td>Вероятность дефолта перестраховщика в части ООЧСП, определенная на дату первоначального признания</td>
      </tr>
    </table>
    <h5>3. ДП ОВТ (исходящее)</h5>
    <p>Данные из ДП ОВТ (исходящее) берутся как с интерфейса, так и из загрузочного файла «ДП ОВТ (исходящее)».</p>
    <p>• Таблица «Фактические выплаты по убыткам»</p>
    <p>Для заполнения данной таблицы берутся данные из загрузочного файла «ДП ОВТ (исходящее)» на определенную когорту. Для определенных сущностей также берутся данные с интерфейса из ДП ООЧП (исходящее). Далее представлена таблица, которая описывает логику использования данных:</p>
    <table>
      <tr>
        <th>Листы из загрузочного файла «ДП ОВТ (исходящее)»</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <th colspan="2">Все данные берутся из загрузки ДП ОВТ (исходящее)</th>
      </tr>
      <tr>
        <td>Доля перестраховщика в оплаченных убытках</td>
        <td>Доля в оплач. убытках, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (прям.)</td>
        <td>Доля в расходах на урег.убытков, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (судебн.)</td>
        <td>Доля в судебных расходах на урег.убытков, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (ПВУ)</td>
        <td>Доля в прочих расходах на урег. убытков, Вал.отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Смешанные данные из загрузки «ДП ОВТ (исходящее)» и с интерфейса ДП ООЧП (исходящее) «Выбор доли РУУ…»</th>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ (исходящее)» х Таблица с интерфейса ДП ООЧП (исходящее) по Регрессам «Выбор доли Регрессов в убытках, %»</td>
        <td>Доля в возникн.регр.прав с уч. неполуч., Вал.договора</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ (исходящее)» х Таблица с интерфейса ДП ООЧП (исходящее) по ГОТС «Выбор доли ГОТС в убытках, %»</td>
        <td>Доля в возникн. прав на ГОТС с уч. неполуч., Вал.договора</td>
      </tr>
    </table>
    <p>• Таблица «Ожидаемый поток выплат из резерва убытков T»</p>
    <p>Для заполнения данной таблицы берутся данные с интерфейса из раздела «ДП ОВТ исходящее» из таблицы «Данные для аллокации по когортам».</p>
    <h5>PAA</h5>
    <p>Построение таблиц в РАА немного отличается от GMM. Помимо таблиц по андеррайтинговым годам, также представлены таблицы с денежными потоками для ОВСУ на три валюты.</p>
    <img src="@/assets/img/guide/export-paa-excel-table-re.png" alt="" srcset="">
    <p>Также в конце каждой таблицы находятся фактические денежные потоки на все периоды возникновения:</p>
    <p>1.	ДП ООЧП (исходящее)</p>
    <p>Данные из ДП ООЧП (исходящее) берутся как с интерфейса, так и из загрузочного файла «ДП ООЧП (исходящее)». Для заполнения следующих столбцов берутся данные из ДП ООЧП с интерфейса из таблицы «Ожидаемые потоки в части ООЧП на момент T»:</p>
    <ul>
      <li>Доля в состоявш. убытках, Вал.договора</li>
      <li>Доля в расходах на урег. убытков, Вал.договора</li>
      <li>Доля в судебн. расх. на урег.убытков, Вал.договора</li>
      <li>Доля в прочие расх. на урег.убытков, Вал.договора</li>
      <li>Доля в возникн.регр.прав с уч. неполуч., Вал.договора</li>
      <li>Доля в возникн. прав на ГОТС с уч. неполуч., Вал.договора</li>
    </ul>
    <p>Также с помощью загрузочного файла «ДП ООЧП (исходящее)» и загрузочного файла «Прочие потоки» заполняется столбец «График призн. выручки, Вал.договора». В Т = 0 данный столбец берет значения из загрузочного файла «ДП ООЧП (исходящее)» из листа «Прогноз выручки» из столбца Когорта ХХХХ, Т = 0. Начиная с Т = 1, подтягиваются данные из загрузочного файла «Прочие потоки» из листа «ДП, валюта договора» (для соответствующей когорты) из столбца «Заработанная премия (факт)».</p>
    <p>2. Прочие потоки </p>
    <p>Данные берутся из загрузочных файлов «Прочие потоки» из листов соответствующей когорты. В загрузочном файле по прочим потоком есть три типа данных (три типа листа):</p>
    <p>Далее представлена сводка данных из загрузочного файла и названия столбцов в экспорте, которые они заполняют.</p>
    <table>
      <tr>
        <th>Столбцы из загрузочного файла</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «ДП, валюта договора»</th>
      </tr>
      <tr>
        <td>Заработанная премия (факт)</td>
        <td>График признания выручки</td>
      </tr>
      <tr>
        <td>Перестраховочная премия</td>
        <td>Перестраховочная премия, Вал.договора</td>
      </tr>
      <tr>
        <td>Аквизиц. Комиссия</td>
        <td>Аквизиц. комиссия, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты премии</td>
        <td>Относимые расх., Вал.отчетности</td>
      </tr>
      <tr>
        <td>Возвраты перестраховочных премий за вычетом перестраховочной комиссии</td>
        <td>Возвраты перестраховочных премий за вычетом перестраховочной комиссии, Вал.договора</td>
      </tr>
      <tr>
        <td>Возвраты аквизиционных комиссий</td>
        <td>Возвраты аквизиционных денежных потоков, Вал.договора</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «ДП, валюта отчетности»</th>
      </tr>
      <tr>
        <td>Относимые админ. расх</td>
        <td>Относимые расх., Вал.отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный лист «Ставки дисконтирования»</th>
      </tr>
      <tr>
        <td>Ставки диск. при первонач. признании, вал договора</td>
        <td>Ставки диск. при перв.призн.</td>
      </tr>
      <tr>
        <td>Рыночные ставки, вал договора</td>
        <td>Рыночные ставки диск.</td>
      </tr>
      <tr>
        <th colspan="2">Загрузочный файл «Вероятности дефолта»</th>
      </tr>
      <tr>
        <td>Вероятность дефолта, текущая</td>
        <td>Вер. дефолта перестрах., текущая</td>
      </tr>
      <tr>
        <td>Вероятность дефолта, первоначальное признание</td>
        <td>Вер. дефолта перестрах., перв.призн.</td>
      </tr>
    </table>
    <p>4.	ДП ОВТ (исходящее)</p>
    <p>Данные из ДП ОВТ (исходящее) берутся как с интерфейса, так и из загрузочного файла «ДП ОВТ (исходящее)».</p>
    <p>•	Таблица «Фактические выплаты по убыткам»</p>
    <p>Для заполнения данной таблицы берутся данные из загрузочного файла «ДП ОВТ (исходящее)» на определенную когорту. Для определенных сущностей также берутся данные с интерфейса из ДП ООЧП (исходящее). Далее представлена таблица, которая описывает логику использования данных:</p>
    <table>
      <tr>
        <th>Листы из загрузочного файла «ДП ОВТ (исходящее)»</th>
        <th>Столбцы в экспорте</th>
      </tr>
      <tr>
        <th colspan="2">Все данные берутся из загрузки ДП ОВТ (исходящее)</th>
      </tr>
      <tr>
        <td>Доля перестраховщика в оплаченных убытках</td>
        <td>Доля в оплач. убытках, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (прям.)</td>
        <td>Доля в расходах на урег.убытков, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (судебн.)</td>
        <td>Доля в судебных расходах на урег.убытков, Вал.договора</td>
      </tr>
      <tr>
        <td>Доля в РРУУ (ПВУ)</td>
        <td>Доля в прочих расходах на урег. убытков, Вал.отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Смешанные данные из загрузки «ДП ОВТ (исходящее)» и с интерфейса ДП ООЧП (исходящее) «Выбор доли РУУ…»</th>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ (исходящее)» х Таблица с интерфейса ДП ООЧП (исходящее) по Регрессам «Выбор доли Регрессов в убытках, %»</td>
        <td>Доля в возникн.регр.прав с уч. неполуч., Вал.договора</td>
      </tr>
      <tr>
        <td>Оплаченные убытки загрузка «ДП ОВТ (исходящее)» х Таблица с интерфейса ДП ООЧП (исходящее) по ГОТС «Выбор доли ГОТС в убытках, %»</td>
        <td>Доля в возникн. прав на ГОТС с уч. неполуч., Вал.договора</td>
      </tr>
    </table>
    <p>•	Таблица «Ожидаемый поток выплат из резерва убытков T»</p>
    <p>Для заполнения данной таблицы берутся данные с интерфейса из раздела «ДП ОВТ исходящее» из таблицы «Данные для аллокации по когортам».</p>
    <h5>Месячный экспорт</h5>
    <p>Экспорт месячных денежных потоков можно сделать только на даты, которые равны или больше даты перехода (31.01.2023). Первая выгрузка месячных потоков происходит на 31.01.24, данная выгрузка включает в себя месячные потоки на 31.12.23 и 31.01.24. Далее выгрузка месячных потоков осуществляется за одну отчетную дату. </p>
    <p>В экспорте месячных денежных потоков есть следующие требования для разных сценариев экспорта:</p>
    <ol>
      <li>Загружены только Прочие потоки мес. исх. или ДП ОВТ мес. исх. на отчетную дату</li>
      <ul>
        <li>Выгрузка экспорта проходит без ограничений.</li>
      </ul>
      <li>Загружены ДП ООЧП мес. на отчетную дату</li>
      <ul>
        <li>Загрузка файла «Прочие потоки (мес.) исх.» на отчетную дату является обязательной. В данной загрузке должны быть все когорты, которые есть в файле «ДП ООЧП (мес.)». Также в загрузке могут быть другие когорты, которых нет в ДП ООЧП мес.</li>
        <li>Загрузка ДП ОВТ на отчетную дату не является блокирующей.</li>
      </ul>
    </ol>
    <p>Если экспорт совершается на дату перехода (31.01.2023), то должны быть загружены денежные потоки на 31.12.2023. В данном случае сценарии описанные раннее сохраняются.</p>
    <p>После успешного экспорта пользователь может запустить расчет переданных потоков в ПО «IRAT».</p>
  </div>
</template>
  
<script>
export default {
  name: 'Export',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
